import React from 'react'

import TermsAndConditionsEn from './TermsAndConditionsEn'

const TermsAndConditions = () => {
  return (
    <TermsAndConditionsEn />
  )
}

export default TermsAndConditions
